<template>
    <a
        v-if="href"
        :class="`d-dropdown-item color-${color} ${icon ? 'd-dropdown-item-with-icon' : ''}`"
        :href="href"
        @click="handleClick"
    >
        <DIcon
            v-if="icon"
            :name="icon"
            :size="22"
            class="icon"
        />
        <slot />
    </a>
    <div
        v-else
        class="d-dropdown-item"
        :class="{'d-dropdown-item-with-icon': icon}"
        @click="handleClick"
    >
        <DIcon
            v-if="icon"
            :name="icon"
            :size="22"
            class="icon"
        />
        <slot />
    </div>
</template>

<script>
export default {
    name: 'DDropdownItem',
    props: {
        icon: {
            type: String,
            default: '',
            required: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        href: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: 'secondary'
        }
    },
    emits: ['click'],
    methods: {
        handleClick () {
            if (this.disabled) {
                return
            }
            this.$emit('click')
        }
    }
}
</script>

<style lang="scss">
.d-dropdown-item {
    height: 45px;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 15px;
    align-items: center;
    padding: 0px 15px;

    &-with-icon {
        grid-template-columns: 22px 1fr;
    }
    &:hover {
        background: rgba(0,0,0,0.07);
        cursor: pointer;
    }
    & .icon {
        color: rgba(0,0,0,0.6);
    }
}

a {
    &.color-primary {
        color: var(--colorPrimaryText);
    }
    &.color-secondary {
        color: var(--colorSecondaryText);
    }
    &.color-danger {
        color: var(--colorDangerText);
    }
    &.color-success {
        color: var(--colorSuccessText);
    }
}

.picker .dropdown-menu {
    width: auto !important;
}
</style>
